import { CalculationError } from '@paragon/contract-library';

export class CalculationErrorFactory {
  private static readonly empty: Omit<CalculationError, 'type'> = {
    boundarySide: null,
    boundaryType: null,
    trussSide: null,
  };

  private static topOrBottom(top: boolean) {
    return top ? 'Top' : 'Bottom';
  }

  private static boundary(orderedCuts: boolean) {
    return orderedCuts ? 'OrderedCuts' : 'Inferred';
  }

  private static leftRightOrBoth(left: boolean, right: boolean) {
    const value = left ? (right ? 'LeftAndRight' : 'Left') : right ? 'Right' : null;
    if (!value) throw new Error('Expected at least one of left or right to be true');
    return value;
  }

  public static nullContainerSolid(): CalculationError {
    return { ...this.empty, type: 'NullContainerSolid' };
  }

  public static zedgeEnvelope(): CalculationError {
    return { ...this.empty, type: 'ZedgeEnvelope' };
  }

  public static verticalTerminalOrderedCuts(top: boolean): CalculationError {
    return { ...this.empty, type: 'VerticalTerminalOrderedCuts', boundarySide: this.topOrBottom(top) };
  }

  public static orderedCutsParallelToFace(top: boolean): CalculationError {
    return { ...this.empty, type: 'OrderedCutsParallelToFace', boundarySide: this.topOrBottom(top) };
  }

  public static consecutiveParallelOrderedCuts(top: boolean): CalculationError {
    return { ...this.empty, type: 'ConsecutiveParallelOrderedCuts', boundarySide: this.topOrBottom(top) };
  }

  public static nullCutFacet(top: boolean): CalculationError {
    return { ...this.empty, type: 'NullCutFacet', boundarySide: this.topOrBottom(top) };
  }

  public static disorientedOrderedCuts(left: boolean, right: boolean): CalculationError {
    return { ...this.empty, type: 'DisorientedOrderedCuts', trussSide: this.leftRightOrBoth(left, right) };
  }

  public static boundaryCornerFailure(
    top: boolean,
    left: boolean,
    right: boolean,
    orderedCuts: boolean,
  ): CalculationError {
    return {
      ...this.empty,
      type: 'BoundaryCornerFailure',
      boundarySide: this.topOrBottom(top),
      trussSide: this.leftRightOrBoth(left, right),
      boundaryType: this.boundary(orderedCuts),
    };
  }

  public static boundaryFailure(top: boolean, orderedCuts: boolean): CalculationError {
    return {
      ...this.empty,
      type: 'BoundaryFailure',
      boundarySide: this.topOrBottom(top),
      boundaryType: this.boundary(orderedCuts),
    };
  }

  public static nullTrussPolygon(): CalculationError {
    return { ...this.empty, type: 'NullTrussPolygon' };
  }

  public static missingDependencies(): CalculationError {
    return { ...this.empty, type: 'MissingDependencies' };
  }

  public static panicked(): CalculationError {
    return { ...this.empty, type: 'CalculationPanic' };
  }
}
